import React from "react";
import styles from "./GalleryView.module.css";
import {cardCategories} from "../CardPicker";
import CreditCard from "../CreditCard";

type Props = {
    cardTypes: string[];
};

export default function GalleryView(props: Props) {
    return (
        <div className={styles.gallery}>
            {props.cardTypes.slice(0, 6).map((t) => {
                const cardCategory = cardCategories.find((c) => c.cardType === t);
                if (!cardCategory) return null;
                return (
                    <div key={cardCategory.id} className={styles.galleryCard}>
                        <CreditCard
                            imageAlt={cardCategory.cards[0].name}
                            imageSources={cardCategory.cards[0].images}
                            textColor={cardCategory.textColor}
                        />
                    </div>
                );
            })}
        </div>
    );
}
